    import React, { useState, useEffect } from 'react';
    import axios from 'axios';
    import { useNavigate, useParams } from 'react-router-dom';
   
    import { FaArrowLeft, FaSpinner } from 'react-icons/fa';
    import { toast } from 'react-toastify';
    // import './Leads.css';


    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

    const getUserDataFromCookies = () => {
            const cookies = document.cookie.split("; ");
            for (let cookie of cookies) {
                const [name, value] = cookie.split("=");
                if (name === 'userData') {
                    return JSON.parse(decodeURIComponent(value));
                }
            }
            return null;
        };

        const userData = getUserDataFromCookies();
        const userRoleId = userData ? userData.role_id : null;

    const ConverttoClientForm = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [clientData, setClientData] = useState({
        business_name: '',
        contact_name: '',
        phone_number: '',
        email: '',
        bussiness_address: '',
        service_interest: '',
        lead_status: '',
        notes: '',
        assigned_affiliate: '',
        lead_id: '',
        payment_status: '',
        subscription_plan: '',
        affiliate_commission: '',
        start_date: '',
    });

    const [loading, setLoading] = useState(false);
    const [initialLoading, setInitialLoading] = useState(!!id);
    const [error, setError] = useState({});
    const [success, setSuccess] = useState('');
   

    useEffect(() => {
        const fetchLeads = async () => {
        if (id) {
            try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`${API_BASE_URL}get-lead/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setClientData(response.data.leads);
            } catch (err) {
            setError({ form: 'Error fetching lead data.' });
            console.error("Error fetching lead:", err);
            } finally {
            setInitialLoading(false);
            }
        }
        };
        fetchLeads();
    }, [id]);

    // Handle form field changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setClientData((prevData) => ({
        ...prevData,
        [name]: value
        }));

        setError((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError({});
        setSuccess('');

        const token = localStorage.getItem('token');
        const config = {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
        };

        try {
        const url = `${API_BASE_URL}convert-to-client/${id || 0}`;
        await axios.put(url, clientData, config);
        // setSuccess(`Leads ${id ? 'updated' : 'created'} successfully!`);
        toast.success("leads converted to client successfully");    
        setClientData({
            business_name: '',
            contact_name: '',
            phone_number: '',
            email: '',
            bussiness_address: '',
            service_interest: '',
            lead_status: '',
            notes: '',
            assigned_affiliate: '',
            lead_id: '',
            payment_status: '',
            subscription_plan: '',
            affiliate_commission: '',
            start_date: '',
        });
        setTimeout(() => navigate('/client'), 1000);
        } catch (err) {
            if (err.response && err.response.data) {
           console.log("Backend Error Response:", err.response.data); 
        const { args, message } = err.response.data;

        if (args && args.length > 0) {
          const validationErrors = args[0];
          let fieldErrors = {};
            Object.keys(validationErrors).forEach((field) => {
            fieldErrors[field] = validationErrors[field].join(' ');
          });

          setError(fieldErrors);
        } else {
          setError({ form: message || 'Error occurred. Please try again.' });
        }
      } else {
        setError({ form: id ? 'Error updating affiliate. Please try again.' : 'Error creating affiliate. Please try again.' });
      }
      setLoading(false);
    }
    };

    if (initialLoading) {
        return (
        <div className="d-flex">
            <div className='container my-5 flex-grow-1'>
            <p>Loading...</p>
            </div>
        </div>
        );
    }

    return (
        <div className="d-flex flex-column flex-md-row">
      
            <div className='container my-5 flex-grow-1'>
            <div className="card shadow-lg">
                <div className="card-header bg-primary text-white">
                        {/* <h3 className="mb-0">{id ? 'Update Lead' : 'Create Lead'}</h3> */}
                        <h3>Convert to Client </h3>
                </div>
                <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h5>Fill in the details below:</h5>
                    <button className="btn ls-btn main-btn btn-outline-secondary" style={{ width:'120px' }} onClick={() => navigate('/leads')}>
                    <FaArrowLeft /> Back
                    </button>
                </div>
                {loading && (
                    <div className="alert alert-info d-flex align-items-center">
                    <FaSpinner className="spin me-2" /> {id ? 'Updating...' : 'Submitting...'}
                    </div>
                )}
                {/* {error.form && <div className="alert alert-danger">{error.form}</div>} */}
                {success && <div className="alert alert-success">{success}</div>}
                <form onSubmit={handleSubmit}>
                    <div className="row">
                    {['business_name', 'contact_name', 'phone_number', 'email', 'bussiness_address'].map((field, index) => (
                        <div className="col-12 col-md-6 mb-3" key={index}>
                        <label htmlFor={field} className="form-label">{field.replace('_', ' ').toUpperCase()}:
                            {field === 'business_name' && <span className="text-danger">*</span>}
                        </label>
                        <div className="input-group">
                            <span className="input-group-text">
                            <i className={`bi bi-${field === 'phone_number' ? 'phone' : field === 'email' ? 'envelope' : 'person'}`}></i>
                            </span>
                            <input
                            type={field === 'phone_number' ? 'tel' : 'text'}
                            id={field}
                            name={field}
                            className="form-control"
                            placeholder={`Enter ${field.replace('_', ' ')}`}
                            value={clientData[field]}
                            onChange={handleChange}
                            />
                            {error[field] && <div className="text-danger">{error[field]}</div>}
                        </div>
                        </div>
                    ))}
                    </div>
                    <div className="row">
                    <div className="col-12 col-md-6 mb-3">
                        <label htmlFor="service_interest" className="form-label">Service Interest:<span className="text-danger">*</span></label>
                        <select
                        id="service_interest"
                        name="service_interest"
                        className="form-control"
                        value={clientData.service_interest}
                        onChange={handleChange}
                        >
                        <option value="">Select Service Interest:</option>
                        <option value="1">Website</option>
                        <option value="2">Google Listing</option>
                        <option value="3">E-Commerce</option>
                        </select>
                        {error.service_interest && <div className="text-danger">{error.service_interest}</div>}
                    </div>
                    <div className="col-12 col-md-6 mb-3">
                        <label htmlFor="lead_status" className="form-label">Lead Status:<span className="text-danger">*</span></label>
                        <select
                        id="lead_status"
                        name="lead_status"
                        className="form-control"
                        value={clientData.lead_status}
                        onChange={handleChange}
                        >
                        <option value="">Select Lead Status:</option>
                        <option value="1">New</option>
                        <option value="2">Contacted</option>
                        <option value="3">Interested</option>
                        <option value="4">Converted</option>
                        </select>
                        {error.lead_status && <div className="text-danger">{error.lead_status}</div>}
                    </div>
                    </div>
                    <div className="row">
                    <div className="col-12 col-md-6 mb-3">
                        <label htmlFor="notes" className="form-label">Notes:</label>
                        <input
                        type="text"
                        id="notes"
                        name="notes"
                        className="form-control"
                        value={clientData.notes}
                        onChange={handleChange}
                        />
                    </div>
                   <div className="col-12 col-md-6 mb-3">
                  <label htmlFor="payment_status" className="form-label">
                      Payment Status:<span className="text-danger">*</span>
                  </label>
                  <select
                      id="payment_status"
                      name="payment_status"
                      className="form-control"
                      value={clientData.payment_status}
                      onChange={handleChange}
                  >
                      <option value="">Select</option>
                      <option value="1">Paid</option>
                      <option value="2">Pending</option>
                      <option value="3">Not Paid</option>
                  </select>
                  {error.payment_status && <div className="text-danger">{error.payment_status}</div>}
              </div>

                    <div className="col-12 col-md-6 mb-3">
                        <label htmlFor="subscription_plan" className="form-label">Subscription Plan:<span className="text-danger">*</span></label>
                        <select
                        id="subscription_plan"
                        name="subscription_plan"
                        className="form-control"
                        value={clientData.subscription_plan}
                        onChange={handleChange}
                        >
                        <option value="">Select</option>
                        <option value="1">Basic ₹99/month</option>
                        <option value="2">E-commerce ₹1499/month</option>
                       </select>
                        {error.subscription_plan && <div className="text-danger">{error.subscription_plan}</div>}
                    </div>
                    <div className="col-12 col-md-6 mb-3">
                        <label htmlFor="payment_date" className="form-label">Payment Date:</label>
                        <input
                        type="date"
                        id="payment_date"
                        name="payment_date"
                        className="form-control"
                        value={clientData.payment_date}
                        onChange={handleChange}
                        />
                    </div>
                    <div className="col-12 col-md-6 mb-3">
                        <label htmlFor="start_date" className="form-label">Start Date:<span className="text-danger">*</span></label>
                        <input
                        type="date"
                        id="start_date"
                        name="start_date"
                        className="form-control"
                        value={clientData.start_date}
                        onChange={handleChange}
                        />
                        {error.start_date && <div className="text-danger">{error.start_date}</div>}                
                        </div>

                            {userRoleId === 1 && (
                            <div className="col-12 col-md-6 mb-3">
                            <label htmlFor="assigned_affiliate" className="form-label">
                                Assigned Affiliate:<span className="text-danger">*</span>
                            </label>
                            <select
                                id="assigned_affiliate"
                                name="assigned_affiliate"
                                className="form-control"
                                value={clientData.assigned_affiliate}
                                onChange={handleChange}
                            >
                                <option value="">Select</option>
                                <option value="1">Tushar</option>
                                <option value="2">Upamanyu</option>
                                <option value="3">Dhanshri</option>
                                <option value="4">Kaveri</option>
                            </select>
                            {error.assigned_affiliate && <div className="text-danger">{error.assigned_affiliate}</div>}
                            </div>
                            )}
                    </div>
                    <button type="submit" className="btn btn-primary" disabled={loading}>
                    {loading ? <FaSpinner className="spin" /> : 'Submit'}
                    </button>
                </form>
                </div>
            </div>
            </div>
        </div>
    );
    };

    export default ConverttoClientForm;
